import { NHIType } from "../../../../../../utils/constants";
import AtlassianAPIKeyDetailsView from "./AtlassianAPIKeyDetailsView";
import AtlassianAPITokenDetailsView from "./AtlassianAPITokenDetailsView";
import AWSIAMUserDetailsView from "./AWSIAMUserDetailsView";
import AWSKmsKeyDetailsView from "./AWSKmsKeyDetailsView";
import AWSSecretDetailsView from "./AWSSecretDetailsView";
import AzureKeyVaultCertificateDetailsView from "./AzureKeyVaultCertificateDetailsView";
import AzureKeyVaultKeyDetailsView from "./AzureKeyVaultKeyDetailsView";
import AzureKeyVaultSecretDetailsView from "./AzureKeyVaultSecretDetailsView";
import ClaudeAPIKeyDetailsView from "./ClaudeAPIKeyDetailsView";
import GitHubOrgAppDetailsView from "./GitHubOrgAppDetailsView";
import GitHubOrgTokenDetailsView from "./GitHubOrgTokenDetailsView";
import GitHubSecretDetailsView from "./GitHubSecretDetailsView";
import GitLabAccessTokenDetailsView from "./GitLabAccessTokenDetailsView";
import GitLabVariableDetailsView from "./GitLabVariableDetailsView";
import JamfAPIKeyDetailsView from "./JamfAPIKeyDetailsView";
import MicrosoftActiveDirectoryServiceUserDetailsView from "./MicrosoftActiveDirectoryServiceUserDetailsView";
import MicrosoftEntraIDApplicationDetailsView from "./MicrosoftEntraIDApplicationDetailsView";
import MongoAPIKeyDetailsView from "./MongoAPIKeyDetailsView";
import OktaTokenDetailsView from "./OktaTokenDetailsView";
import OpenAIAdminAPIKeyDetailsView from "./OpenAIAdminAPIKeyDetailsView";
import SalesforceOAuthTokenDetailsView from "./SalesforceOAuthTokenDetailsView";
import SlackSaaSNHIDetailsView from "./SlackSaaSNHIDetailsView";
import SnowflakeServiceUserDetailsView from "./SnowflakeServiceUserDetailsView";

const NonHumanIdentityDetailsView = ({ entityData }) => {
  if (entityData?.subtype === NHIType.OKTA_TOKEN) {
    return <OktaTokenDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AWS_SECRET) {
    return <AWSSecretDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AWS_KMS_KEY) {
    return <AWSKmsKeyDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AWS_IAM_USER) {
    return <AWSIAMUserDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.GITHUB_SECRET) {
    return <GitHubSecretDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.GITLAB_ACCESS_TOKEN) {
    return <GitLabAccessTokenDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.GITLAB_VARIABLE) {
    return <GitLabVariableDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.GITHUB_ORG_TOKEN) {
    return <GitHubOrgTokenDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AZURE_KEYVAULT_KEY) {
    return <AzureKeyVaultKeyDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AZURE_KEYVAULT_SECRET) {
    return <AzureKeyVaultSecretDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.AZURE_KEYVAULT_CERTIFICATE) {
    return <AzureKeyVaultCertificateDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.SNOWFLAKE_SERVICE_USER) {
    return <SnowflakeServiceUserDetailsView entityData={entityData} />;
  } else if (
    entityData?.subtype === NHIType.SALESFORCE_OAUTH_TOKEN &&
    entityData?.salesforce_oauth_token_data
  ) {
    return <SalesforceOAuthTokenDetailsView entityData={entityData} />;
  } else if (entityData?.subtype === NHIType.SLACK_SAAS_NHI) {
    return <SlackSaaSNHIDetailsView entityData={entityData} />;
  } else if (entityData?.mongo_atlas_api_key_data) {
    return <MongoAPIKeyDetailsView entityData={entityData} />;
  } else if (entityData?.claude_api_keys_data) {
    return <ClaudeAPIKeyDetailsView entityData={entityData} />;
  } else if (entityData?.atlassian_api_key_data) {
    return <AtlassianAPIKeyDetailsView entityData={entityData} />;
  } else if (entityData?.atlassian_api_token_data) {
    return <AtlassianAPITokenDetailsView entityData={entityData} />;
  } else if (entityData?.jamf_api_key_data) {
    return <JamfAPIKeyDetailsView entityData={entityData} />;
  } else if (entityData?.openai_admin_api_key_data) {
    return <OpenAIAdminAPIKeyDetailsView entityData={entityData} />;
  } else if (entityData?.microsoft_entra_id_application_data) {
    return <MicrosoftEntraIDApplicationDetailsView entityData={entityData} />;
  } else if (entityData?.github_org_app_data) {
    return <GitHubOrgAppDetailsView entityData={entityData} />;
  } else if (entityData?.microsoft_active_directory_service_user_data) {
    return (
      <MicrosoftActiveDirectoryServiceUserDetailsView entityData={entityData} />
    );
  } else {
    return <></>;
  }
};

export default NonHumanIdentityDetailsView;
